import { useState, useEffect, useRef } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Tooltip
} from '@mui/material';


// FIXME: write up simple parameter info
export default function Popup({ openText, openVariant, header, content, sx, tooltip, buttonSuccess, successAction, successCloses, successDisabled, buttonCancel }) {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = useRef(null);
    useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;

            if (descriptionElement !== null) descriptionElement.focus();
        }
    }, [open]);

    return (<>
        <Tooltip title={tooltip}>
            <Button onClick={handleOpen} variant={openVariant || "outlined"} sx={sx}>{openText || "Open popup"}</Button>
        </Tooltip>
        <Dialog
            open={open}
            onClose={handleClose}
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            className="Popup"
            sx={{ minWidth: "75%", maxWidth: "75%", display: 'block', margin: 'auto' }}
        >
            <DialogTitle id="scroll-dialog-title">{header || ""}</DialogTitle>
            <DialogContent dividers>
                <DialogContentText
                    id="scroll-dialog-description"
                    ref={descriptionElementRef}
                    tabIndex={-1}
                >
                    {content}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>{buttonCancel || "Close"}</Button>
            {successAction && <Button
                variant="contained"
                onClick={() => {
                    successAction()
                    if (successCloses) handleClose();
                }}
                disabled={successDisabled}
            >
                {buttonSuccess || "Submit"}
            </Button>}
            </DialogActions>
        </Dialog>
    </>);
}
